import React from "react";

const ConstructionStatus = ({
  selectedConustruction = [],
  handleConustructionPress,
}) => {
  const consustatus = [
    { id: "1", name: "Ready to move" },
    { id: "2", name: "Under Construction" },
    { id: "3", name: "New Launch" },
  ];

  return (
    <div className="mainbarfiltercomponents">
      {consustatus.map((construct, index) => {
        const isChecked = selectedConustruction.some(
          (c) => c.toLowerCase() === construct.name.toLowerCase()
        );
        return (
          <div
            className="propertyboxes"
            key={index}
            onClick={() =>
              handleConustructionPress &&
              handleConustructionPress(construct.name)
            }
            style={{ cursor: "pointer" }}
          >
            <input
              type="checkbox"
              checked={isChecked}
              onChange={() => {}}
              style={{ cursor: "pointer" }}
            />
            <p className="propertytextpara" style={{ margin: 0, paddingLeft: "8px" }}>
              {construct.name}
            </p>
          </div>
        );
      })}
    </div>
  );
};

export default ConstructionStatus;